/* global Word */

export async function getDocumentContents(): Promise<string> {
  /**
   * Get the whole document contents.
   * @returns {Promise<string>}
   */
  return await Word.run(function (context) {
    const body = context.document.body
    const range = body.getRange('Whole')
    range.load('text')
    return context.sync().then(() => {
      return range.text
    })
  })
}

export function getSelectedText(): Promise<string> {
  /**
   * Get the selected text in the document.
   * @returns {Promise<string>}
   */
  return Word.run(async function (context) {
    const range = context.document.getSelection()
    range.load('text')
    await context.sync()
    return range.text
  })
}

export function getSelectedRange(): Promise<Word.Range> {
  /**
   * Get the selected range in the document.
   * @returns {Promise<Word.Range>}
   */
  return Word.run(async function (context) {
    const range = context.document.getSelection()
    range.load('text')
    await context.sync()
    return range
  })
}

export async function getRangeAfterIndex(
  range: Word.Range,
  rangeText: string,
  index: number
): Promise<Word.Range> {
  /**
   * Given a Range, the text of the range, and an index, return the range that is after the index.
   * We do this by best-effort string match.
   * @param {Word.RequestContext} context
   * @param {Word.Range} range
   * @param {string} rangeText
   * @param {number} index
   * @returns {Promise<Word.Range>}
   */
  const searchText = rangeText.substring(Math.max(0, index - 250), index) // Search length max is 255
  const search = range.split([searchText])
  search.load('items')
  await range.context.sync()
  const rangeAfterIndex =
    search.items.length > 1
      ? search.items[1].expandTo(search.items[search.items.length - 1])
      : search.items[0]
  rangeAfterIndex.load('text')
  await rangeAfterIndex.context.sync()
  return rangeAfterIndex
}

export async function subsetRange(
  range: Word.Range,
  rangeStart: number,
  rangeEnd: number
) {
  const charRanges = range.search('?', { matchWildcards: true })
  charRanges.load('items')
  await charRanges.context.sync()
  const targetRange = charRanges.items[rangeStart].expandTo(
    charRanges.items[rangeEnd - 1]
  )
  targetRange.load()
  await targetRange.context.sync()
  return targetRange
}
